module.exports = __webpack_public_path__ + "976b3364b371f187413671a4f331509c.fbx";